/**
 * @file コンポーネント：プライバシーポリシー日本語 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledPrivacypolicyBody } from "./style";

// Presenterを返す
export const Presenter = () => {
    // ReactDOM
    return (
        <StyledPrivacypolicyBody>
            <h3>
                個人情報保護方針（プライバシーポリシー）
            </h3>
            <p>
                OPExPARKは、IoT技術を用いて手術室をデジタル化し、<br />
                世界中の医師が、どこにいても現場にいるかのような<br />
                「手術経験を共有できる場」の提供を実現していきます。
            </p>
            <p>
                私たちは手術室をそのまままるごとデジタル化し、<br />
                執刀医の手術戦略・術中の判断といった暗黙知の視える化を可能にします。<br />
                また地域や国境の壁を越え、まるで現場にいるかのように情報を共有する<br />
                全く新しいプラットフォームを提供します。
            </p>
            <p>
                将来的にはデータを利用したAIサージェリー、ロボット手術への貢献や<br />
                手術室を飛び出し病院全体、医療全体のスマート化の実現にも<br />
                活用が期待され、世界中の「誰も」が「安全」に「安心」して<br />
                治療を受けられる未来を目指していきます。
            </p>
            <p>
                私たちはミッションを達成するために、術中情報融合プラットフォーム「OPeLiNK」によってこれまで医師個人に集積されていた優れた手術の技術を視える化すること、手技デジタル教科書プラットフォーム「opeXpark」によって、手技を学ぶために留学をせずともまるで手術室の中で学んでいるかのような体験を共有することで世界の手術格差の是正に挑んでいます。
            </p>
            <p>
                私たちが取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、本人の権利の保護、個人情報に関する法規制等を遵守致します。
            </p>
            <ul>
                <li>
                    私たちは、提供するサービスの実現のため、お客様の個人情報を必要な範囲で、適正な方法で取得と利用を行います。
                </li>
                <li>
                    私たちは、お客様の個人情報を守るために、徹底した安全管理を行います。
                </li>
                <li>
                    私たちは、お客様の権利を尊重します。個人情報の開示を求められた場合は、法令に則り、速やかに対応します。
                </li>
            </ul>
            <p>
                本プライバシーポリシーでは、当社が提供するすべてのサービス（以下「本サービス」といいます）をお客様にご利用いただくにあたり、お客様の個人情報をどのような目的でどのように取り扱うかを以下の通りに定めております。
            </p>
            <section>
                <h4>
                    個人情報の取得
                </h4>
                <p>
                    当社は、お客様が本サービスを利用する際に、個人情報（個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます））を取得および利用することがあります。
                </p>
            </section>
            <section>
                <h4>
                    個人情報の利用目的
                </h4>
                <p>
                    当社は、個人情報を以下の目的で利用することができるものとします。
                </p>
                <dl>
                    <dt>
                        会員制webサイトopeXparkの会員に関する個人情報の利用目的
                    </dt>
                    <dd>
                        <p>
                            以下の目的で個人情報を利用します。
                        </p>
                        <ul>
                            <li>
                                お客様の本人確認、認証
                            </li>
                            <li>
                                お問い合わせへの対応および対応品質の改善
                            </li>
                            <li>
                                システムの保守・改善・不具合対応
                            </li>
                            <li>
                                不正アクセス行為、スパム行為等の不正利用を防止
                            </li>
                            <li>
                                医学分野における調査・研究
                            </li>
                            <li>
                                手術をはじめとする医療情報、学術情報の提供、収集
                            </li>
                            <li>
                                医療従事者向けの生活、経営等の情報提供
                            </li>
                            <li>
                                お客様の本サービス利用に関するデータ分析
                            </li>
                            <li>
                                お客様の本サービスの利用状況の分析結果を踏まえた本サービスの改善、新規サービスの開発
                            </li>
                            <li>
                                当社または第三者の商品およびサービスに関連する広告その他の情報の提供
                            </li>
                            <li>
                                当社または製薬会社、医療機器会社その他の第三者の社内教育および自社マーケティング活動
                            </li>
                        </ul>
                    </dd>
                    <dt>
                        患者様に関する個人情報の利用目的
                    </dt>
                    <dd>
                        <p>
                            以下の目的で個人情報を利用します。
                        </p>
                        <ul>
                            <li>
                                将来の医療技術の発展、研究のためのデータベースへの蓄積
                            </li>
                            <li>
                                教材作成、並びに、その電子教材を利用する日本国内・海外の医療機関・医師への情報共有
                            </li>
                            <li>
                                医学分野における調査・研究
                            </li>
                            <li>
                                当社または第三者の商品およびサービスに関連する広告
                            </li>
                            <li>
                                医学、医療技術の発展、普及に資する内容の行為並びに製薬会社、医療機器会社等の社内教育および営業
                            </li>
                        </ul>
                    </dd>
                    <dt>
                        採用応募者の方々に関する個人情報の利用目的
                    </dt>
                    <dd>
                        <p>
                            以下の目的で個人情報を利用します。
                        </p>
                        <ul>
                            <li>
                                採否の検討、決定及び連絡
                            </li>
                        </ul>
                        <p>
                            当社は、「2．個人情報の利用目的」記載の利用目的を、相当の関連性を有すると合理的に認められる範囲で変更することができるものとします。
                        </p>
                    </dd>
                </dl>
            </section>
            <section>
                <h4>
                    個人情報の適切な取得
                </h4>
                <p>
                    当社は、個人情報を適切に取得し、偽りその他不正の手段により取得することはありません。
                </p>
            </section>
            <section>
                <h4>
                    個人情報の安全管理
                </h4>
                <p>
                    私たちは、個人情報の紛失、破壊、改ざん、漏洩などのリスクに対して、個人情報の安全管理が図られるよう、従業員に対する必要かつ適切な監督を行います。また、個人情報の取り扱いの全部または一部を委託する場合には、委託先においても個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。ただし、本サービスを利用する際に取得するアカウントおよびパスワードは、本サービスの利用規約に基づき、お客様の責任において管理されるものとします。
                </p>
            </section>
            <section>
                <h4>
                    第三者への提供
                </h4>
                <p>
                    当社は、会員等の事前の同意がある場合、および次に定める場合でない限り、会員等の個人情報を第三者に提供いたしません。
                </p>
                <dl>
                    <dt>
                        法令に基づき開示を許容される場合
                    </dt>
                    <dt>
                        人の生命、身体または財産の保護のために必要がある場合であって、会員本人の同意を得ることが困難である場合
                    </dt>
                    <dt>
                        公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、会員の同意を得ることが困難である場合
                    </dt>
                    <dt>
                        国の機関若しくは地方公共団体又は国の委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、会員の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
                    </dt>
                    <dt>
                        合併その他の組織再編に関わる事由に伴って個人情報が提供される場合
                    </dt>
                    <dt>
                        自社製品のマーケティングや研究開発、社内教育等の事業活動に利用する目的で、医師の情報を必要としている顧客（主に製薬会社、医療機器会社を想定）に対し、個人情報を提供する場合
                    </dt>
                    <dt>
                        「2．個人情報の利用目的」記載の利用目的の達成に必要な場合
                    </dt>
                </dl>
                <p>
                    なお、ご本人の請求がございましたら、当社は当該本人を識別可能な個人情報の提供を停止いたしますので、本ページ記載のお問合せ窓口までお申し出ください。
                </p>
            </section>
            <section>
                <h4>
                    個人情報の開示
                </h4>
                <p>
                    当社は、個人情報保護法の規定に基づき、会員から個人情報の開示を求められた場合、会員本人からの請求であることを確認した上で、遅滞なく会員に開示します。(当該個人情報が存在しない場合は、その旨をご連絡いたします。)ただし、個人情報保護法その他の法令により、当社が開示義務を負わない場合はこの限りではありません。
                </p>
            </section>
            <section>
                <h4>
                    個人情報の利用停止について
                </h4>
                <p>
                    当社は、会員が公表した利用目的の範囲を超えて会員の個人情報が取り扱われていること、または偽りその他不正の手段により取得されたものであることを理由として、個人情報保護法の規定に基づき、利用の停止または消去（以下「利用停止等」といいます）を求められた場合、その求めに理由があることが判明した場合には、会員本人からの求めであることを確認します。これを確認した後、遅滞なく個人情報の利用を停止し、その旨を会員に通知します。ただし、個人情報保護法その他の法令により、当社が利用停止の義務を負わない場合はこの限りではありません。
                </p>
            </section>
            <section>
                <h4>
                    クッキーおよびその他の技術の使用について
                </h4>
                <p>
                    本サービスでは、クッキーおよびそれに類する技術を使用することがあります。これらの技術は、本サービスの利用状況を把握し、サービスの向上に役立てています。クッキーを無効にしたい会員は、ウェブブラウザの設定を変更することにより、クッキーを無効にすることができます。ただし、クッキーを無効にした場合、本サービスの一部の機能が利用できなくなることがあります。なお、この技術を利用することにより、会員が入力していない個人情報を取得することはありません。
                </p>
            </section>
            <section>
                <h4>
                    セキュリティについて
                </h4>
                <p>
                    会員情報は、プライバシー保護とセキュリティのため、パスワードで保護されています。また、必要に応じて業界標準のSSL暗号を使用し、データ転送を保護しています。
                </p>
            </section>
            <section>
                <h4>
                    本ポリシーの改定について
                </h4>
                <p>
                    当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めることとし、本ポリシーを一部改訂することがあります。重要な変更がある場合には、サイト上でお知らせいたします。
                </p>
            </section>
            <section>
                <h4>
                    プライバシーに関するお問い合わせ
                </h4>
                <p>
                    プライバシーに関するご意見・お問い合わせは、info@opexpark.co.jp までご連絡ください。
                </p>
            </section>
            <p>
                最終改定日：2022年02月02日
            </p>
        </StyledPrivacypolicyBody>
    );
};
